// This is needed so we can mock redirectToNewUrl in tests since it
// is difficult to mock window.location
export default (redirectUrl => window.location.href = redirectUrl);